import { mapActions } from 'vuex'
import { dateToShow, dateToMysql } from '@/helpers/dates'
import { isEmpty } from 'lodash'

const prepareSave = data => {
  const registration = {...data}
  if (isEmpty(registration.attachment.content)) {
    delete registration.attachment
  }

  registration.birthdate = dateToMysql(registration.birthdate)
  registration.record = dateToMysql(registration.record)

  return registration
}

const prepareShow = data => {
  const registration = {...data}

  registration.birthdate = dateToShow(registration.birthdate)
  registration.record = dateToShow(registration.record)

  return registration
}

export default {
  ...mapActions(['updateUserData']),
  collapsibleOne () {
    this.setpTwocollapsibleOne = true
    this.setpTwocollapsibleTwo = false
    this.setpTwocollapsibleThree = false
  },
  collapsibleTwo () {
    this.setpTwocollapsibleOne = false
    this.setpTwocollapsibleTwo = true
    this.setpTwocollapsibleThree = false
  },
  collapsibleThree () {
    this.setpTwocollapsibleOne = false
    this.setpTwocollapsibleTwo = false
    this.setpTwocollapsibleThree = true
  },
  doSaveSetpOne () {
    this.$v.$touch()
    this.$nextTick(() => this.focusFirstStatus())

    if (this.$v.$error) {
      return
    }
    const registration = prepareSave(this.registration)
    this.$resource.update('me', registration)
      .then(({data}) => {
        // Removido, atualizva os dados do usuario após quaçlquer alteração
        // this.updateUserData(data)
        // this.beenUpdated = true
        // this.show = true
        this.setpTwocollapsibleOne = false
        this.setpTwocollapsibleTwo = true
        this.setpTwocollapsibleThree = false
      })
      .catch(({data}) => {
        this.errors = data
      })
  },
  doSaveSetpTwo () {
    this.$v.$touch()
    this.$nextTick(() => this.focusFirstStatus())

    if (this.$v.$error) {
      return
    }
    const registration = prepareSave(this.registration)
    this.$resource.update('me', registration)
      .then(({data}) => {
        // Removido, atualizva os dados do usuario após quaçlquer alteração
        // this.updateUserData(data)
        this.beenUpdated = true
        this.show = true
        this.setpTwocollapsibleOne = false
        this.setpTwocollapsibleTwo = true
        this.setpTwocollapsibleThree = false
      })
      .catch(({data}) => {
        this.errors = data
      })
  },
  doLoad () {
    this.$resource.get('/me')
      .then(({data}) => {
        this.registration = prepareShow(data)
      })
  },
  focusFirstStatus (component = this) {
    if (component.status) {
      component.$el.focus()
      return true
    }

    let focused = false

    component.$children.some((childComponent) => {
      focused = this.focusFirstStatus(childComponent)
      return focused
    })

    return focused
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/record/registration/resources/methods.js